export const APP_VERSION = '0a5159d0-1785928249663'
